import React, { useEffect, useState } from "react";
import { Alert, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  getCompetencyQuestions,
  deleteCompetencyQuestion,
  editCompetencyQuestion,
  saveCompetencyQuestion,
} from "../../redux/evaluacion_desempenio/competencyEvaluationQuestions/actions";

const QuestionCompetencyComponent = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [saveLoaderEdit, setSaveLoaderEdit] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState("");
  const [formError, setFormError] = useState("");
  const [timer, setTimer] = useState(null);
  const [indexT, setIndexT] = useState(0);
  const dispatch = useDispatch();

  const dataJs = {
    competencia_plantilla_encabezado__id: props.idPlantilla,
    competencia_id: String(props.item.id),
  };

  useEffect(() => {
    dispatch(
      getCompetencyQuestions(
        {
          //tipo_busqueda: "plantilla",
          //filter: props.idPlantilla,
          tipo_busqueda: "filtrado_competencia_y_encabezado", //competencia_periodicidad `{"periodicidad_id:" ${props.idPeriodicidad}, "competencia_id:" ${props.id_competencia}}`
          filter: JSON.stringify(dataJs), //  '{"periodicidad_id": "26", "competencia_id": "25" }' , // dos llaves id_periodiciddad id_competencia
        },

        setData,
        setCount,
        setLoader,
        setError,
        setFormError
      )
    );
    // }
  }, [props.functionSelected, props._viewMessege]);

  useEffect(() => {
    if (props.resetFunction) {
      setData([]);
      setCount(0);
    }
  }, [props.resetFunction]);

  const handleSubmit = (
    pregunta,
    id_competencia,
    tempCompetencia,
    tempValIndex
  ) => {
    const req = {
      pregunta: pregunta,
      competencia: props.item.id,
      clasificacion: props.item.clasificacion,
      periodicidad: props.idPeriodicidad,
      competencia_plantilla_encabezado: props.idPlantilla,
    };
    if (tempCompetencia === undefined) {
      //req.competencia = props.item.competencia;
      dispatch(
        saveCompetencyQuestion(
          req,
          data,
          setData,
          count,
          setCount,
          setSaveLoader,
          setError,
          setFormError
        )
      );
    } else {
      dispatch(
        editCompetencyQuestion(
          req,
          tempCompetencia.id,
          tempValIndex,
          data,
          setData,
          count,
          setCount,
          setSaveLoaderEdit,
          setError,
          setFormError
        )
      );
    }
  };

  return (
    <>
      {!!error && (
        <Alert variant="danger" className="mt-1 mb-2">
          {error}
        </Alert>
      )}
      {!!formError && (
        <Alert variant="danger" className="mt-1 mb-2">
          {formError}
        </Alert>
      )}
      {loader ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : (
        [1, 2, 3, 4].map((_item, _indexT) => (
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Pregunta {_item}
            </Form.Label>
            <Col sm={10}>
              <Row>
                {saveLoader && indexT === _indexT ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                      size="sm"
                    />
                  </div>
                ) : (
                  <Col sm="12">
                    <Form.Control
                      name="competencia"
                      className="col rounded-pill"
                      defaultValue={
                        data &&
                          data[parseInt(_indexT)] &&
                          data[parseInt(_indexT)].pregunta
                          ? data[parseInt(_indexT)].pregunta.toUpperCase()
                          : ""
                      }
                      onChange={(e) => {
                        setIndexT(_indexT)
                        const Value = e.currentTarget.value;
                        if (timer) {
                          clearTimeout(timer);
                          setTimer(null);
                        }
                        setTimer(
                          setTimeout(() => {
                            if (data && data[parseInt(_indexT)] !== undefined) {
                              handleSubmit(
                                Value,
                                props.item.id,
                                data[parseInt(_indexT)],
                                parseInt(_indexT)
                              );
                            } else {
                              handleSubmit(
                                Value,
                                props.item.id,
                                undefined,
                                parseInt(_indexT)
                              );
                            }
                          }, 3000)
                        );
                      }}
                      type="text"
                      disabled={parseInt(_indexT) > count}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          </Form.Group>
        ))
      )}
    </>
  );
};
export default QuestionCompetencyComponent;
